import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {computed, reactive, watch} from "vue";
import {message} from "ant-design-vue";
import {editor} from "@/app/editor";
import {PlusOutlined} from "@ant-design/icons-vue";
import BlockView from "@/components/block/BlockView.vue";
import BlockTitleView from "@/components/block/BlockTitleView.vue";
import {IconFont} from "@/lib/util";
import {ForwardModuleV1} from "@/app/editor/modules/forward/v1/forward_v1";
import {IActivityGift} from "@/app/editor/types";
import BlockContentBox from "@/components/block/BlockContentBox.vue";
import BlockContentItemKey from "@/components/block/BlockContentItemKey.vue";
import BlockContentItemValue from "@/components/block/BlockContentItemValue.vue";
import GiftPickView from "@/app/editor/views/GiftPickView.vue";
import GiftItemView from "@/app/editor/views/GiftItemView.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForwardSetup',
  props: {
    index: {}
  },
  setup(__props: any) {


const props = __props
const forward = editor.activity?.modules[props.index] as ForwardModuleV1

const info = reactive({item: {open: false, gift: null as IActivityGift | null}})

const maxOption = computed((): number => {
  let n = 0
  if (forward.config.share_local_group_limit.enable) n++
  if (forward.config.timeline_like_limit.enable) n++
  if (forward.config.share_timeline_limit.enable) n++
  return n
})

watch(maxOption, n => {
  if (n > 0) forward.config.complete_count = 1
})

const cleanItem = () => {
  info.item.open = false
}
const addItem = () => {
  if (info.item.gift) {
    forward.config.gifts.push(info.item.gift)
    info.item.open = false
  } else message.warn('没有选中礼品')
}

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(forward) && _unref(editor).activity)
      ? (_openBlock(), _createBlock(BlockView, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(BlockTitleView, null, {
              default: _withCtx(() => [
                _createVNode(_unref(IconFont), {
                  type: `icon-${_unref(forward).icon}`,
                  style: {"padding-right":"8px"}
                }, null, 8, ["type"]),
                _createTextVNode(" " + _toDisplayString(_unref(forward).title), 1)
              ]),
              _: 1
            }),
            _createVNode(BlockContentBox, null, {
              default: _withCtx(() => [
                _createVNode(BlockContentItemKey, null, {
                  default: _withCtx(() => [
                    _createTextVNode("连续分享朋友圈")
                  ]),
                  _: 1
                }),
                _createVNode(BlockContentItemValue, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: _unref(forward).config.share_timeline_limit.amount,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(forward).config.share_timeline_limit.amount) = $event)),
                      disabled: !_unref(forward).config.share_timeline_limit.enable,
                      max: 99,
                      min: 1,
                      "addon-after": "天"
                    }, {
                      addonBefore: _withCtx(() => [
                        _createVNode(_component_a_switch, {
                          checked: _unref(forward).config.share_timeline_limit.enable,
                          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_unref(forward).config.share_timeline_limit.enable) = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    }, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(BlockContentItemKey, null, {
                  default: _withCtx(() => [
                    _createTextVNode("朋友圈集赞")
                  ]),
                  _: 1
                }),
                _createVNode(BlockContentItemValue, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: _unref(forward).config.timeline_like_limit.amount,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(forward).config.timeline_like_limit.amount) = $event)),
                      disabled: !_unref(forward).config.timeline_like_limit.enable,
                      max: 999,
                      min: 1,
                      "addon-after": "赞"
                    }, {
                      addonBefore: _withCtx(() => [
                        _createVNode(_component_a_switch, {
                          checked: _unref(forward).config.timeline_like_limit.enable,
                          "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_unref(forward).config.timeline_like_limit.enable) = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    }, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(BlockContentItemKey, null, {
                  default: _withCtx(() => [
                    _createTextVNode("转发到本地生活群")
                  ]),
                  _: 1
                }),
                _createVNode(BlockContentItemValue, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: _unref(forward).config.share_local_group_limit.amount,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(forward).config.share_local_group_limit.amount) = $event)),
                      disabled: !_unref(forward).config.share_local_group_limit.enable,
                      max: 99,
                      min: 1,
                      "addon-after": "个"
                    }, {
                      addonBefore: _withCtx(() => [
                        _createVNode(_component_a_switch, {
                          checked: _unref(forward).config.share_local_group_limit.enable,
                          "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_unref(forward).config.share_local_group_limit.enable) = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    }, 8, ["value", "disabled"])
                  ]),
                  _: 1
                }),
                (maxOption.value>0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(BlockContentItemKey, null, {
                        default: _withCtx(() => [
                          _createTextVNode("要求")
                        ]),
                        _: 1
                      }),
                      _createVNode(BlockContentItemValue, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: _unref(forward).config.complete_count,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(forward).config.complete_count) = $event)),
                            options: [...Array(maxOption.value).keys()].map(i => ({value:i+1,label:`完成任意${i+1}项`}))
                          }, null, 8, ["value", "options"])
                        ]),
                        _: 1
                      }),
                      _createVNode(BlockContentItemKey, null, {
                        default: _withCtx(() => [
                          _createTextVNode("达成礼品")
                        ]),
                        _: 1
                      }),
                      _createVNode(BlockContentItemValue, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_flex, {
                            vertical: "",
                            gap: "middle"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_a_button, {
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (info.item.open=true)),
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("添加")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_a_flex, {
                                gap: "middle",
                                wrap: "wrap"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(forward).config.gifts, (g, i) => {
                                    return (_openBlock(), _createBlock(GiftItemView, {
                                      key: i,
                                      gift: g,
                                      closeable: "",
                                      onOnClose: ($event: any) => (_unref(forward).config.gifts.splice(i,1))
                                    }, null, 8, ["gift", "onOnClose"]))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_drawer, {
      open: info.item.open,
      "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((info.item.open) = $event)),
      title: "选择礼品",
      placement: "right",
      size: "large"
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_flex, { gap: "small" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, { onClick: cleanItem }, {
              default: _withCtx(() => [
                _createTextVNode("取消")
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: addItem
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(GiftPickView, {
          gift: info.item.gift,
          "onUpdate:gift": _cache[8] || (_cache[8] = ($event: any) => ((info.item.gift) = $event))
        }, null, 8, ["gift"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})